import { Controller } from '@hotwired/stimulus';

export default class extends Controller {
  static targets = ['caption'];
  static values = { interval: { type: Number, default: 3000 } };

  connect() {
    if (this.captionTargets.length <= 1) return;

    this.index = 0;
    this.timer = setInterval(() => this.advance(), this.intervalValue);
  }

  disconnect() {
    if (this.timer) clearInterval(this.timer);
  }

  advance() {
    for (const target of this.captionTargets) {
      if (target.classList.contains('is-leaving')) {
        target.classList.add('no-transition');
        target.classList.remove('is-leaving');
        target.offsetHeight;
        target.classList.remove('no-transition');
      }
    }

    const current = this.captionTargets[this.index];
    current.classList.remove('is-active');
    current.classList.add('is-leaving');

    this.index = (this.index + 1) % this.captionTargets.length;
    this.captionTargets[this.index].classList.add('is-active');
  }
}
